/**
Provides a basic undo stack storing opaque states. The consumer is
expected to provide a `restoreState` method which is invoked when undoing or
redoing.

The consumer should call `pushState` to push states onto the undo stack.
*/

type Constructor<T={}> = abstract new (...args: any[]) => T

Observable from @danielx/observable

export Undo := <Base extends Constructor>(S: Base) =>
  abstract class Undo extends S
    undoStack: unknown[] = []
    undoIndex = Observable -1

    maxUndoStackSize = 20

    undoDisabled = =>
      @undoIndex() <= 0

    redoDisabled = =>
      @undoIndex() >= @undoStack.length - 1

    popState = =>
      unless @undoDisabled()
        @undoStack[@undoIndex.decrement(1)]

    nextState = =>
      unless @redoDisabled()
        @undoStack[@undoIndex.increment(1)]

    pushState = (state: unknown) =>
      // Discard
      @undoStack = @undoStack.slice(0, @undoIndex()+1).slice(-@maxUndoStackSize)

      // Push
      @undoIndex @undoStack.push(state) - 1

      @trigger "changed"

    undo = =>
      if state := @popState()
        @restoreState(state)
        @trigger "changed"

    redo = =>
      if state := @nextState()
        @restoreState(state)
        @trigger "changed"

    abstract trigger(event: string, ...parameters: any[]): unknown
    abstract restoreState(state: unknown): void

  return Undo

export default Undo
